import { APPLICATION_STATUS } from '../utils/Constants';

export interface IStatusProps {
  applicationStatus: number;
}

const useStatus = ({ applicationStatus }: IStatusProps) => {
  const isApproved = applicationStatus === APPLICATION_STATUS.approved.code;
  const isRejected = applicationStatus === APPLICATION_STATUS.rejected.code;
  const isInCommittee = applicationStatus === APPLICATION_STATUS.committee.code;
  const isPending = applicationStatus === APPLICATION_STATUS.pending.code;
  const isInRevision = applicationStatus === APPLICATION_STATUS.revision.code;
  const isInInstrumentation =
    applicationStatus === APPLICATION_STATUS.instrumentation.code;
  const isReadyToInstrument = applicationStatus === APPLICATION_STATUS.readyToInstrument.code;
  const isFinished = applicationStatus === APPLICATION_STATUS.finished.code;

  const isStatusNaN = isNaN(applicationStatus);
  const isFinalStatus = [
    APPLICATION_STATUS.rejected.code,
    APPLICATION_STATUS.approved.code,
    APPLICATION_STATUS.committee.code,
    APPLICATION_STATUS.instrumentation.code,
    APPLICATION_STATUS.readyToInstrument.code,
    APPLICATION_STATUS.finished.code,
  ].includes(applicationStatus);

  return {
    isApproved,
    isRejected,
    isInCommittee,
    isPending,
    isInRevision,
    isFinalStatus,
    isInInstrumentation,
    isReadyToInstrument,
    isFinished,
    isStatusNaN,
  };
};

export default useStatus;
